import Proxy from './Proxy';

class ExcelFileProxy extends Proxy {

  constructor(parameters = {}) {
    super('api/media/excels', parameters);
  }

}

export default ExcelFileProxy;
